import React from 'react';
import VoiceCommandApp from './components/VoiceCommandApp';
import './App.css';

function App() {
  return (
    <div className="App">
      <VoiceCommandApp />
    </div>
  );
}

export default App;